import axios from "axios";
import authHeader from "./auth-header";
import apihostname from "./apihostname";

const instance = axios.create({
  baseURL: apihostname,
  headers: authHeader(),
});

const head = { "Content-Type": "multipart/form-data" };
const instance2 = axios.create({
  baseURL: apihostname,
  headers: { ...authHeader(), ...head },
});

class FarmerService {
  getUserlist() {
    return instance.get("/users/list");
  }
  getListcontract() {
    return instance.get("/list-contract");
  }
  getFarmerlist() {
    return instance.get("/listfarmer");
  }
  getFarmerSearch(body) {
    return instance.post("/listfarmer-search", body);
  }
  createFarmer(userid, body) {
    return instance2.post("/farmers/new", body, {
      user: {
        user_id: userid,
      },
    });
  }
  deleteFarmer(id) {
    return instance.delete("/farmers/" + id);
  }
  readCard() {
    return axios.get("http://localhost:5000/get_data");
  }
  getPhotoByCard() {
    return axios.get("http://localhost:5000/get_photo_json");
  }
  getFarmerById(id) {
    return instance.get("/farmers/" + id);
  }
  updateFarmerById(body) {
    return instance2.post("/farmerupdate", body);
  }

  getIdByExternal(body, user_id) {
    return instance.post("/personalsimple", body, {
      user: {
        user_id: user_id,
      },
    });
  }
  setCronJobStatus(body) {
    return instance.post("set-cron-job", body);
  }
  getCornJobStatus() {
    return instance.get("/get-cron-job");
  }
  stopCornJobStatus() {
    return instance.get("/stop-cron-job");
  }
  resetCornJobStatusCheck() {
    return instance.post("/reset-cron-job-check");
  }
  setCronJobAddress(body) {
    return instance.post("set-cron-job-address", body);
  }
  getCornJobAddress() {
    return instance.get("/get-cron-job-address");
  }
  stopCornJobAddress() {
    return instance.get("/stop-cron-job-address");
  }
  resetCornJobAddressCheck() {
    return instance.post("/reset-cron-job-address_check");
  }
}

export default new FarmerService();
